// removed by extract-text-webpack-plugin
module.exports = {"component":"Search__component___25HEZ","wrapper":"Search__wrapper___2ej9u","field":"Search__field___y8S14","fieldShort":"Search__fieldShort___2JPCl","button":"Search__button___1QDws","buttonSmaller":"Search__buttonSmaller___32FSc","text":"Search__text___3T7b-"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/Search.css
// module id = 410
// module chunks = 0